import { scoreBandToken } from './score'

export interface ScoreChipProps {
  value: number | null | undefined
  size?: 'sm' | 'md'
  className?: string
}

export function ScoreChip({ value, size = 'sm', className = '' }: ScoreChipProps) {
  const sizeCls = size === 'md' ? 'h-7 px-2 text-sm' : 'h-5 px-1.5 text-xs'
  const tokens = scoreBandToken(value)
  const display = value == null ? '—' : Math.round(value)
  const srLabel =
    value == null
      ? 'No investigation score'
      : `Investigation score ${Math.round(value)} — ${tokens.label}`
  return (
    <span
      className={`inline-flex items-center rounded-md font-semibold tabular-nums ${sizeCls} ${tokens.bg} ${tokens.text} ${className}`}
    >
      <span className="sr-only">{srLabel}</span>
      <span aria-hidden="true">{display}</span>
    </span>
  )
}
